<app-header></app-header>
<div class="checkout-container">
  @if (isActive) {
    <div    class="title-checkout"><h1>{{ 'checkout.title' | translate }}</h1></div>
  }
  @if (!isActive) {
    <div    class="title-checkout"><h1>{{ 'checkout.maintenanceTitle' | translate }}</h1></div>
  }
  <div class="checkout-detail">
    <div class="checkout-column left-column">
      <!-- Bloque de inicio de sesión y registro -->
      <!-- <div *ngIf="!auth.isLoggedIn()" class="login-register-block">
      <h2>¿Tiene cuenta?</h2>
      <div class="button-login">
        <button (click)="showLoginPopup()" class="btn-login">Iniciar Sesión</button>
        <button class="btn-register">Registrarse</button>
      </div>
    </div> -->

    <!-- Formulario de checkout -->
    @if (isActive) {
      <div class="checkout-form-block"><div class="checkout-dialog">
        <h2>{{ 'checkout.shipping.title' | translate }}</h2><button   (click)="togglemisdirecciones()"><img src="/assets/icons/plus.svg" alt="">{{ 'checkout.shipping.myAddressesButton' | translate }}</button>
      </div><form [formGroup]="form" >
      <!-- Columna izquierda del formulario -->
      <div class="form-column">
        <div class="form-group">
          <label for="nombre">{{ 'checkout.shipping.name.label' | translate }}</label>
          <input [formControl]="form.controls['name']"  type="text" id="nombre" name="nombre" [placeholder]="'checkout.shipping.name.placeholder' | translate" required>
          @if (form.controls['name'].hasError('required') && form.controls['name'].touched) {
            <small
            class="form-error-msg"> {{ 'checkout.shipping.name.required' | translate }} </small>
          }
        </div>
        <div class="form-group">
          <label for="apellido">{{ 'checkout.shipping.lastname.label' | translate }}</label>
          <input  [formControl]="form.controls['lastname']" type="text" id="apellido" name="apellido" [placeholder]="'checkout.shipping.lastname.placeholder' | translate" required>
          @if (form.controls['lastname'].hasError('required') && form.controls['lastname'].touched) {
            <small
            class="form-error-msg"> {{ 'checkout.shipping.lastname.required' | translate }} </small>
          }
        </div>
        <div class="form-group">
          <label for="direccion">{{ 'checkout.shipping.address.label' | translate }}</label>
          <input [formControl]="form.controls['address']" type="text" id="direccion" name="direccion" [placeholder]="'checkout.shipping.address.placeholder' | translate" required>
          @if (form.controls['address'].hasError('required') && form.controls['address'].touched) {
            <small
            class="form-error-msg"> {{ 'checkout.shipping.address.required' | translate }} </small>
          }
        </div>
        @if (!auth.isLoggedIn()) {
          <div  class="form-group">
            <label for="email">{{ 'checkout.shipping.email.label' | translate }}</label>
            <input  [formControl]="form.controls['email']"  type="email" id="email" name="email" [placeholder]="'checkout.shipping.email.placeholder' | translate" required>
            @if (form.controls['email'].hasError('required') && form.controls['email'].touched) {
              <small
              class="form-error-msg"> {{ 'checkout.shipping.email.required' | translate }} </small>
            }
          </div>
        }
        <div class="form-group">
          <label for="provincia">{{ 'checkout.shipping.province.label' | translate }}</label>
          <select  (change)="onProvinceChange()" [formControl]="form.controls['province']" id="provincia" name="provincia">
            <option disabled="" selected="" value="">{{ 'checkout.shipping.province.placeholder' | translate }}</option>
            @for (p of provinces; track p) {
              <option [value]="p.id" >{{p.name}}</option>
            }
          </select>
          @if (form.controls['province'].hasError('required') && form.controls['province'].touched) {
            <small
            class="form-error-msg"> {{ 'checkout.shipping.province.required' | translate }} </small>
          }
        </div>
        <div class="form-group">
          <label for="corregimiento">{{ 'checkout.shipping.corregimiento.label' | translate }}</label>
          <select [formControl]="form.controls['corregimiento']" id="corregimiento" name="corregimiento">
            <option disabled="" selected="" value="">{{ 'checkout.shipping.corregimiento.placeholder' | translate }}</option>
            @for (c of corregimientos; track c) {
              <option [value]="c.id" >{{c.name}}</option>
            }
          </select>
          @if (form.controls['corregimiento'].hasError('required') && form.controls['corregimiento'].touched) {
            <small
            class="form-error-msg"> {{ 'checkout.shipping.corregimiento.required' | translate }} </small>
          }
        </div>
      </div>
      <hr>
        <div class="checkout-dialog">
          <h2  class="pago">{{ 'checkout.payment.title' | translate }}</h2> @if (auth.isLoggedIn()) {
          <button (click)="togglemistarjetas()"><img src="/assets/icons/plus.svg" alt="">{{ 'checkout.payment.myCardsButton' | translate }}</button>
        }
      </div>
      <div class="form-group">
        <label for="tarjeta">{{ 'checkout.payment.cardName.label' | translate }}</label>
        <input [formControl]="form.controls['name_tdc']" type="text" id="tarjeta" name="cc-name" [placeholder]="'checkout.payment.cardName.placeholder' | translate" required>
        @if (form.controls['name_tdc'].hasError('required') && form.controls['name_tdc'].touched) {
          <small
          class="form-error-msg"> {{ 'checkout.payment.cardName.required' | translate }} </small>
        }
      </div>
      <div class="form-group">
        <label for="numero-tarjeta">{{ 'checkout.payment.cardNumber.label' | translate }}</label>
        <input (keypress)="onlyNumberKey($event)" [formControl]="form.controls['number_tdc']"  type="text" id="numero-tarjeta" name="cc-number" [placeholder]="'checkout.payment.cardNumber.placeholder' | translate" required>
        @if (form.controls['number_tdc'].hasError('required') && form.controls['number_tdc'].touched) {
          <small
          class="form-error-msg"> {{ 'checkout.payment.cardNumber.required' | translate }} </small>
        }
      </div>
      <div class="datos-mac">
        <div class="form-group">
          <label for="mes-expiracion">{{ 'checkout.payment.expirationMonth.label' | translate }}</label>
          <select [formControl]="form.controls['month']"  id="mes-expiracion" name="mes-expiracion" required>
            <option value="" disabled selected>{{ 'checkout.payment.expirationMonth.placeholder' | translate }}</option>
            <option value="01" id="mes-exp-0">{{ 'checkout.payment.expirationMonth.months.january' | translate }}</option>
            <option value="02" id="mes-exp-1">{{ 'checkout.payment.expirationMonth.months.february' | translate }}</option>
            <option value="03" id="mes-exp-2">{{ 'checkout.payment.expirationMonth.months.march' | translate }}</option>
            <option value="04" id="mes-exp-3">{{ 'checkout.payment.expirationMonth.months.april' | translate }}</option>
            <option value="05" id="mes-exp-4">{{ 'checkout.payment.expirationMonth.months.may' | translate }}</option>
            <option value="06" id="mes-exp-5">{{ 'checkout.payment.expirationMonth.months.june' | translate }}</option>
            <option value="07" id="mes-exp-6">{{ 'checkout.payment.expirationMonth.months.july' | translate }}</option>
            <option value="08" id="mes-exp-7">{{ 'checkout.payment.expirationMonth.months.august' | translate }}</option>
            <option value="09" id="mes-exp-8">{{ 'checkout.payment.expirationMonth.months.september' | translate }}</option>
            <option value="10" id="mes-exp-9">{{ 'checkout.payment.expirationMonth.months.october' | translate }}</option>
            <option value="11" id="mes-exp-10">{{ 'checkout.payment.expirationMonth.months.november' | translate }}</option>
            <option value="12" id="mes-exp-11">{{ 'checkout.payment.expirationMonth.months.december' | translate }}</option>
          </select>
          @if (form.controls['month'].hasError('required') && form.controls['month'].touched) {
            <small
            class="form-error-msg"> {{ 'checkout.payment.expirationMonth.required' | translate }} </small>
          }
        </div>
        <div class="form-group">
          <label for="ano-expiracion">{{ 'checkout.payment.expirationYear.label' | translate }}</label>
          <select [formControl]="form.controls['year']"  id="ano-expiracion" name="ano-expiracion" required>
            <option value="" disabled selected>{{ 'checkout.payment.expirationYear.placeholder' | translate }}</option>
            @for (year of expirationYears; track year) {
              <option [value]="year.value">{{ year.label }}</option>
            }
          </select>
          @if (form.controls['year'].hasError('required') && form.controls['year'].touched) {
            <small
            class="form-error-msg"> {{ 'checkout.payment.expirationYear.required' | translate }} </small>
          }
        </div>
        <div class="form-group">
          <label for="cvv">{{ 'checkout.payment.cvv.label' | translate }}</label>
          <input maxlength="3"  (keypress)="onlyNumberKey($event)"  [formControl]="form.controls['ccv']" type="password" id="cvv" name="cvv" [placeholder]="'checkout.payment.cvv.placeholder' | translate">
        </div> </div>
        <button (click)="checkout()" class="btn-submit">{{ 'checkout.submitButton' | translate }}</button>
      </form>
    </div>
  }
</div>


@if (isActive) {
  <div class="checkout-summary">
    <h2>{{ 'checkout.summary.title' | translate }}</h2>
    <div class="product-item">
      <img src="/assets/images/1.png" alt="Producto 1">
      <div class="product-info">
        <h3>{{ 'checkout.summary.planName' | translate }}</h3>
        <p>{{ 'checkout.summary.description' | translate }}</p>
      </div>
    </div>
    <hr>
      <!-- Total -->
      <div class="order-total">
        <p>{{ 'checkout.summary.total' | translate }}</p>
      </div>
    </div>
  }

</div>
</div>

